import { api as t } from "../utils/configuration.js";
import { crudService as s } from "../js/request-DH6Y2P3c.js";
const o = {
  register: (e) => s.post(e, t.ACCOUNTS_URL),
  me: (e, i) => s.get(`${t.ACCOUNTS_URL}/me`, { ...e, signal: i }),
  updateProfile: (e) => s.put(e, `${t.ACCOUNTS_URL}/me`),
  validations: (e, i) => s.get(`${t.ACCOUNTS_URL}/me/validations`, {
    params: { unitId: e },
    signal: i
  }),
  requestSms: (e) => s.post(e, `${t.ACCOUNTS_URL}/verification/request-sms`),
  submitSms: (e) => s.post(e, `${t.ACCOUNTS_URL}/verification/validate-sms`),
  requestEmail: (e) => s.post(e, `${t.ACCOUNTS_URL}/verification/request-email`),
  validateEmail: ([e], i) => s.get(`${t.ACCOUNTS_URL}/verification/validate-email/${e}`, { signal: i }),
  requestPasswordReset: (e) => s.post(e, `${t.ACCOUNTS_URL}/request-password-reset`),
  tokenPasswordReset: (e) => s.post(e, `${t.ACCOUNTS_URL}/reset-password`)
};
export {
  o as AccountService
};
//# sourceMappingURL=account.js.map
